<template>
    <svg :width="fullWidth" :height="height">
        <rect :key="index" :x="0" :y="0" :width="percentWidth" :height="height" fill="#0ABFC2" />
        <text :key="index" :x="percentWidth + 25" :y="height / 2 + 6" text-anchor="middle" font-size="12px" fill="#0ABFC2">{{ percent.toFixed(2) }}%</text>

    </svg>
</template>

<script>
export default {
    props: {
        percent: {
            type: Number,
            required: true,
            default: 50
        },
        fullWidth: {
            type: Number,
            required: true,
            default: 300
        },
        height: {
            type: Number,
            default: 14,
        },
    },
    computed: {
        percentWidth() {
            return (this.fullWidth / 100) * this.percent;
        },
    },
};
</script>